/**
* DevExpress Dashboard (_expression-editor.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { DashboardExpressionEditor } from '../expression-editor/_expression-editor';
import { getExpressionEditorFunctions } from '../expression-editor/_expression-editor-functions';
export class CalculationExpressionEditor {
    constructor(params) {
        this.params = params;
        this.editorTemplate = 'dx-dashboard-calculation-expression-editor';
        this.editor = new ExpressionEditorWrapper(params);
        this.criteriaString = ko.computed(() => {
            var criteria = params.options().value();
            return criteria;
        });
    }
    edit() {
        this.editor.show();
    }
    remove() {
        this.params.options().value(null);
    }
}
export class ExpressionEditorWrapper {
    constructor(params) {
        this.params = params;
        this.viewModel = ko.observable();
    }
    show() {
        if (this.viewModel()) {
            this.viewModel().dispose();
        }
        var expressionEditorOptions = this.params.options();
        expressionEditorOptions.functions = getExpressionEditorFunctions();
        var editor = new DashboardExpressionEditor(expressionEditorOptions, this.params.fieldListProvider, this.params.displayNameProvider);
        editor.textAreaValue(expressionEditorOptions.value());
        editor.popupVisible(true);
        this.viewModel(editor);
    }
}
